import * as React from 'react';

import { Header } from 'pages/components';
import { Layout } from 'components';
import { P2PForm } from './components';

const P2P = () => <Layout header={<Header />} main={<P2PForm />} />;

export default P2P;
